import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove } from '@dnd-kit/sortable';
import { useEffect, useState } from 'react';
import { Flex } from 'antd';
import DragAndDropItem from './drag-and-drop-item';

const DragAndDrop = ({
  dragItems = [],
  itemOrder = [],
  setItemOrder = () => {},
  itemStyle = {},
  vertical = true,
  children = <></>,
}) => {
  const [items, setItems] = useState(dragItems);

  useEffect(() => {
    setItems(dragItems);
  }, [dragItems]);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over?.id) return;
    if (active?.id !== over?.id) {
      setItems((items) => {
        const oldIndex = items?.map((i) => i?.id).indexOf(active?.id);
        const newIndex = items?.map((i) => i?.id).indexOf(over?.id);
        setItemOrder(arrayMove(itemOrder, oldIndex, newIndex));
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  return (
    <DndContext onDragEnd={handleDragEnd} sensors={sensors}>
      <SortableContext items={items}>
        <Flex wrap vertical={vertical} gap={vertical ? 8 : 16}>
          {items.map((data) => {
            return <DragAndDropItem key={data?.id} id={data?.id} data={data} itemStyle={itemStyle} />;
          })}
          {children}
        </Flex>
      </SortableContext>
    </DndContext>
  );
};

export default DragAndDrop;
